import React from "react";
import styles from "../document/document.module.css";
import backgroundImage from "./../../assets/16.09.2022-2-1-2.jpg";

export const Personal = () => {
  const documentList = [];

  const backgroundStyle = {
    backgroundSize: "cover",
  };

  return (
    <div style={backgroundStyle}>
      <div className={styles.documentsPage}>
        <header className={styles.header}>
          <h1>
            ა(ა)იპ ბათუმის წმინდა ანდრია პირველწოდებულის სახელობის სკოლის
            პერსონალურ მონაცემთა დაცვის ოფიცერი
          </h1>
        </header>
        <div className={styles.documentsContainer}>
          <section style={{ marginTop: "20px", marginBottom: "20px" }}>
              <div style={{fontSize: "20px", textAlign: "center", width: "900px"}}>
                გიორგი გაბუნია - 557 71 11 07
              </div>
          </section>
        </div>
      </div>
    </div>
  );
};
